/* src/app/components/payroll/timesheets/timesheet-adjust-void-entry/timesheet-adjust-void-entry.component.css */
::ng-deep ppl-dialog div.popup-dialog.position-dialog div.content.medium {
  width: 90vw;
  max-width: 90%;
}
::ng-deep ppl-dialog div.popup-dialog.position-dialog.limit-dialog-width div.content.medium {
  max-width: 65%;
}
::ng-deep p-calendar.error-border input {
  border: 1px solid red;
}
.table-scroll-wrapper {
  width: 100%;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
}
.timesheet-adjust-table {
  table-layout: fixed;
  width: 100%;
  font-size: 12px;
  border-collapse: separate;
  border-spacing: 0;
}
.timesheet-adjust-table.wide-layout {
  min-width: 1600px;
}
.timesheet-adjust-table th,
.timesheet-adjust-table td {
  border: none;
  padding: 8px 10px !important;
  vertical-align: top;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.timesheet-adjust-table tr {
  vertical-align: top !important;
}
.timesheet-adjust-table th {
  font-weight: 600;
  line-height: 1.3;
}
.timesheet-adjust-table .ant-select,
.timesheet-adjust-table input.ant-input,
.timesheet-adjust-table nz-date-picker,
.timesheet-adjust-table p-datePicker,
.timesheet-adjust-table p-calendar {
  font-size: 12px !important;
  width: 100% !important;
}
.timesheet-adjust-table .ant-select-selector,
.timesheet-adjust-table .ant-picker,
.timesheet-adjust-table input.ant-input {
  height: 32px !important;
  min-height: 32px !important;
  box-sizing: border-box !important;
  padding: 0 11px !important;
  border-radius: 4px;
}
.timesheet-adjust-table .ant-select-single .ant-select-selector .ant-select-selection-item,
.timesheet-adjust-table .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
  line-height: 30px;
}
.timesheet-adjust-table nz-date-picker .ant-picker-input,
.timesheet-adjust-table nz-date-picker .ant-picker-input > input {
  width: 100%;
  height: 100%;
  font-size: 12px !important;
  line-height: 30px !important;
  color: rgba(0, 0, 0, 0.88);
  padding: 0;
  border: none;
  background: transparent;
}
.timesheet-adjust-table p-datePicker,
.timesheet-adjust-table p-calendar {
  display: block;
  width: 100%;
}
.timesheet-adjust-table p-datePicker .p-inputtext,
.timesheet-adjust-table p-calendar .p-inputtext {
  width: 100%;
  height: 32px;
  box-sizing: border-box;
  padding: 0 11px;
  font-size: 12px;
  line-height: 30px;
  border-radius: 4px;
}
.timesheet-adjust-table .previous-value {
  display: inline-block;
  width: 100%;
  word-break: break-word;
  line-height: 1.4;
  color: #333;
}
.required-marker {
  color: red;
}
.error-message {
  color: red;
  font-size: 11px;
  min-height: 14px;
  line-height: 1.3;
}
.save-row {
  margin-top: 16px;
  padding: 0 4px;
}
/*# sourceMappingURL=timesheet-adjust-void-entry.component-P7FX656A.css.map */
